<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} reserva
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body p-15">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off" class="m-b-50">
          <div id="accordion">
            <div class="card mb-0">
              <div class="card-header book__accordion__header" id="headingGeneral">
                <h5 class="mb-0 mt-0 font-14">
                  <a data-parent="#accordion" aria-controls="general" class="book__accordion__title">
                    <i class="fas fa-info-circle m-r-5"></i>Datos Generales
                  </a>
                </h5>
              </div>
              <div id="general" class="collapse show" aria-labelledby="headingGeneral" data-parent="#accordion">
                <div class="card-body p-l-10 p-r-10">
                  <div class="row">
                    <div class="form-group col-lg-6">
                      <label id="client_label">Cliente responsable <span class="required"></span>
                        <div class="book__nrodoc m-l-20" *ngIf="clientSelected != null">
                          ( {{clientSelected.typeDocument}} : {{clientSelected.document}} )
                          <ng-container *ngIf="!item.value.is_client_guest">
                            <span class="badge badge-primary f-s-10 pointer" (click)="addClientHowGuest()">¿Es huésped?
                              <i class="fas fa-arrow-down"></i></span>
                          </ng-container>
                        </div>
                      </label>
                      <ng-container *ngIf="clientSelected != null">
                        <div class="input-group">
                          <input type="text" class="form-control form-control-sm" disabled
                            value="{{clientSelected.fullname}}">
                          <div class="input-group-append bg-custom b-0 removeClient">
                            <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                              (click)="removeClient()">
                              <i class="fas fa-backspace w-100 f-s-12"></i>
                            </div>
                            <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                              data-toggle="modal" data-target="#openExtendsClient"
                              (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                              <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="clientSelected == null">
                        <div class="input-group input-group-grid">
                          <component-search-client [classSize]="'search-small'"
                            (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                          </component-search-client>
                          <div class="input-group-append b-0">
                            <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                              data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                              <i class="fas fa-user-plus w-100"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div class="form-group col-lg-3">
                      <label>Número teléfono</label>
                      <div class="input-group">
                        <input type="text" class="form-control form-control-sm" id="tel_1" formControlName="tel_1"
                          remove-spaces-number placeholder="Tel 1">
                        <div class="input-group-append">
                          <div class="input-group-text p-l-2 p-r-2">-</div>
                        </div>
                        <input type="text" class="form-control form-control-sm" id="tel_2" formControlName="tel_2"
                          remove-spaces-number placeholder="Tel 2">
                      </div>
                    </div>
                    <!-- <div class="form-group col-lg-3">
                      <label>Origen reserva <span class="required"></span></label>
                      <select class="form-control form-control-sm" id="originBookingSelected"
                        formControlName="bookingorigin_id" required>
                        <option *ngFor="let item of originsbooking" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div> -->
                    <div class="form-group col-lg-3">
                      <label>Tipo Tarifa <span class="required"></span></label>
                      <select class="form-control form-control-sm" id="typeRateSelected" formControlName="typerate_id"
                        required (change)="changeTypeRate()">
                        <option *ngFor="let item of type_rates" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div>
                    <ng-container *ngIf="item.value.typerate_id == 3">
                      <div class="form-group col-lg-6">
                        <label>Seleccionar empresa convenio<span class="required"></span>
                          <ng-container *ngIf="companyAgreement != null">
                            <span class="m-l-15 bold"><i
                                class="fas fa-phone m-r-5"></i>{{companyAgreement.cellphone}}</span>
                          </ng-container>
                        </label>
                        <ng-container *ngIf="companyAgreement != null">
                          <div class="input-group">
                            <input type="text" class="form-control form-control-sm" disabled
                              value="{{companyAgreement.tradename}}-{{companyAgreement.document_str}}">
                            <div class="input-group-append bg-custom b-0 removeClient">
                              <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                                uib-tooltip="Quitar" (click)="removePartner()">
                                <i class="fas fa-backspace w-100 f-s-12"></i>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="companyAgreement == null">
                          <component-search-partnercompanies [classSize]="'search-small'"
                            (selectedPartnerEvent)="selectedCompanyAgreementSearch($event)" class="w-100">
                          </component-search-partnercompanies>
                          <div>
                            <span class="badge badge-warning f-s-11">Debe seleccionar la empresa para aplicar la tarifa
                              convenio en las habitaciones</span>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="item.value.typerate_id != 3">
                      <div class="form-group col-lg-6">
                        <label>Asociar empresa
                          <ng-container *ngIf="companyAgreement != null">
                            <span class="m-l-15 bold"><i
                                class="fas fa-phone m-r-5"></i>{{companyAgreement.cellphone}}</span>
                          </ng-container>
                        </label>
                        <ng-container *ngIf="companyAgreement != null">
                          <div class="input-group">
                            <input type="text" class="form-control form-control-sm" disabled
                              value="{{companyAgreement.tradename}}-{{companyAgreement.document_str}}">
                            <div class="input-group-append bg-custom b-0 removeClient">
                              <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                                uib-tooltip="Quitar" (click)="removePartner()">
                                <i class="fas fa-backspace w-100 f-s-12"></i>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="companyAgreement == null">
                          <component-search-partnercompanies [classSize]="'search-small'"
                            [placeholderText]="'Buscar empresa'"
                            (selectedPartnerEvent)="selectedCompanyAgreementSearch($event)" class="w-100">
                          </component-search-partnercompanies>
                        </ng-container>
                      </div>
                    </ng-container>

                  </div>
                  <div class="row">
                    <div class="col-lg-12 m-t-10">
                      <p class="form__group__title"> <i class="fas fa-bed m-r-3"></i>Detalle Habitaciones <span
                          class="required m-l-0"></span>
                        <a class="btn btn-sm btn-info m-l-10 f-s-9 bold text-white" id="add_search_bedroom"
                          data-toggle="modal" data-target="#openExtendsAvailableBedrooms"
                          (click)="SearchAvailableBedroomsExtendsComponent.loadData(item.value.typerate_id, companyAgreement)">Búsqueda
                          <i class="fas fa-plus m-l-2"></i>
                        </a>
                      </p>
                    </div>
                    <div class="col-lg-12">
                      <ng-container *ngIf="detail_bedrooms.length == 0">
                        Aun no se han agregado habitaciones
                      </ng-container>
                      <ng-container *ngIf="detail_bedrooms.length > 0">
                        <ng-container *ngFor="let item of detail_bedrooms; let index = index">
                          <div class="m-b-5">
                            <i class="far fa-calendar-alt m-r-5"></i>
                            {{index+1}}° Bloque Habitaciones
                            <i class="fas fa-minus-circle f-s-15 m-l-5 text-danger pointer"
                              (click)="removeBlockBedrooms(index)"></i>
                            <!-- Rango Fechas:
                            <span class="bold">CHECKIN: {{item.date_checkin | date: 'mediumDate'}}</span> / <span
                              class="m-l-10 bold">CHECKOUT: {{item.date_checkout | date: 'mediumDate'}}</span>
                            <span class="m-l-10 f-s-12 text-primary bold">({{item.number_nights}} noches)</span> -->
                          </div>
                          <div class="table-responsive m-b-15">
                            <table class="table mb-0 table-sm">
                              <thead class="thead-default">
                                <tr>
                                  <th class="text-center">N° HAB</th>
                                  <th>Tipo Hab.</th>
                                  <th class="text-center">N°Pax</th>
                                  <th>Check-In</th>
                                  <th>Check-Out</th>
                                  <th class="text-center">Extras <i class="fas fa-plus text-success"></i></th>
                                  <th class="text-center">Noches</th>
                                  <th class="text-right">Subtotal</th>
                                  <th class="text-center"></th>
                                </tr>
                              </thead>
                              <tbody>
                                <ng-container *ngIf="item.bedroom_selecteds.length > 0">
                                  <ng-container *ngFor="let bedroom of item.bedroom_selecteds; let index_ = index">
                                    <tr>
                                      <td class="text-center">
                                        <span class="f-s-13 bold">
                                          {{bedroom.code_number}}
                                        </span>
                                        <div *ngIf="bedroom.is_variation_roomtype"> <span
                                            class="badge badge-info f-s-8">Variable</span></div>
                                      </td>
                                      <td class="nowrap text-center">
                                        <select class="form-control sale__inputSelect"
                                          id="roomTypeSelected{{index}}{{index_}}"
                                          (change)="changeRoomTypeBedroom($event.target, index,index_)">
                                        </select>
                                      </td>
                                      <td class="text-center">{{bedroom.nro_pax}}</td>
                                      <td>
                                        <input type="text" id="date_checkin{{index}}{{index_}}"
                                          class="form-control form-control-xs" [value]="bedroom.date_checkin">
                                      </td>
                                      <td>
                                        <input type="text" id="date_checkout{{index}}{{index_}}"
                                          class="form-control form-control-xs" [value]="bedroom.date_checkout">
                                      </td>
                                      <td>
                                        <select class="form-control sale__inputSelect"
                                          id="selectTypeCharge{{index}}{{index_}}"
                                          (change)="changeTypeCharge($event.target, index,index_)">
                                          <option [value]="null">--Seleccionar--</option>
                                          <option *ngFor="let type of type_charges" [value]="type.id">
                                            {{ type.description }}</option>
                                        </select>
                                      </td>
                                      <td class="text-center bold"><span class="f-s-13">{{bedroom.number_nights}}</span>
                                      </td>
                                      <td class="text-right">
                                        {{toolsService.momeySol()}}{{bedroom.subtotal}}
                                      </td>
                                      <td class="text-center">
                                        <a class="btn btn-sm btn-outline-secondary m-r-10 f-s-11" data-toggle="modal"
                                          data-target="#modalNights" (click)="detailRateBedroom(index,index_)">👁️</a>
                                        <a class="btn btn-sm btn-danger text-white f-s-11" *ngIf="!bedroom.is_checkin"
                                          (click)="removeBedroomSelected(item.id, index, index_)">
                                          <i class="far fa-trash-alt"></i>
                                        </a>
                                        <ng-container *ngIf="bedroom.is_checkin">
                                          <span class="badge bg-checkin text-white">Check-In</span>
                                        </ng-container>

                                      </td>
                                    </tr>

                                    <tr *ngIf="bedroom.detail_charges.length > 0" style="background: #f6fdff;">
                                      <td></td>
                                      <td colspan="5" class="ps-4 py-1 text-right">
                                        <span class="m-r-5 f-s-12">
                                          <strong>Extras agregados:</strong>
                                        </span>
                                        <ng-container
                                          *ngFor="let charge of bedroom.detail_charges; let index_charge = index">
                                          <div class="input-group input-group-sm m-r-15"
                                            style="display: inline-flex; width: auto;">
                                            <span class="input-group-prepend">
                                              <span class="input-group-text f-s-11"
                                                style="background: transparent;">{{charge.description}} | <span
                                                  class="m-l-3">{{toolsService.momeySol()}}{{charge.price}}</span></span>
                                            </span>
                                            <input type="text" class="form-control form-control-xs text-center f-s-12"
                                              (keyup)="quantityTypeCharge($event.target, index,index_,index_charge)"
                                              numeric [value]="charge.quantity" style="width: 45px;"
                                              onclick="click_input(this)">
                                            <span class="input-group-append">
                                              <span class="input-group-text pointer"
                                                (click)="removeTypeCharge(item.id, index, index_, index_charge)">
                                                <i class="fas fa-trash text-danger f-s-12"></i>
                                              </span>
                                            </span>
                                          </div>
                                        </ng-container>
                                      </td>
                                    </tr>
                                  </ng-container>
                                </ng-container>

                              </tbody>
                            </table>
                          </div>
                        </ng-container>
                        <div class="table-responsive">
                          <table class="table mb-0 table-sm">
                            <tbody>
                              <tr>
                                <td class="text-center f-s-14">
                                  <span class="bold f-s-13">
                                    N° TOTAL PAX:
                                  </span>
                                  <span class="m-l-5 f-s-13 bold">{{total_pax}}</span>
                                </td>
                                <td colspan="2" class="bold text-right">
                                  <span class="m-r-10 f-s-14">TOTAL HABITACIONES: </span>
                                  <span class="f-s-14">{{toolsService.momeySol()}}{{total_bedrooms}}</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-0 m-t-20">
              <div class="card-header book__accordion__header" id="headingGuests">
                <h5 class="mb-0 mt-0 font-14">
                  <a data-parent="#accordion" aria-controls="guests" class="book__accordion__title">
                    <i class="fas fa-users m-r-5"></i>Datos Huéspedes
                    <span class="required m-l-0"></span>
                  </a>
                  <a class="btn btn-sm btn-info m-l-10 f-s-9 text-white" data-toggle="modal"
                    data-target="#openExtendsGuests" (click)="GuestsExtendsComponent.loadData()">Agregar
                    <i class="fas fa-plus m-l-2"></i>
                  </a>
                </h5>
              </div>
              <div id="guests" class="collapse show" aria-labelledby="headingGuests" data-parent="#accordion">
                <div class="card-body p-l-10 p-r-10">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="table-responsive">
                        <table class="table mb-0 table-sm">
                          <thead class="thead-default">
                            <tr>
                              <th>Grupo edad</th>
                              <th>Nombres y apellidos</th>
                              <th>N° Documento</th>
                              <th class="text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngIf="detail_guests.length == 0">
                              <tr>
                                <td colspan="4"><span>Aun no se han agregado huéspedes</span></td>
                              </tr>
                            </ng-container>
                            <ng-container *ngIf="detail_guests.length > 0">
                              <tr *ngFor="let item of detail_guests; let index_ = index">
                                <td class="text-uppercase">
                                  <ng-container *ngIf="item.age_group == 1">Adulto</ng-container>
                                  <ng-container *ngIf="item.age_group == 2">Niño</ng-container>
                                  <ng-container *ngIf="item.age_group == 3">Infante</ng-container>
                                </td>
                                <td> {{item.fullname}}
                                  <ng-container *ngIf="item.is_client_resposible">
                                    <span class="badge badge-primary m-l-3 f-s-9">(Es cliente)</span>
                                  </ng-container>
                                </td>
                                <td>{{item.document}}</td>
                                <td class="text-center">
                                  <ng-container *ngIf="!item.is_client_resposible">
                                    <i class="fas fa-pencil-alt pointer f-s-15 text-info m-r-10"
                                      (click)="editGuests(item.id, index_)"></i>
                                  </ng-container>
                                  <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                    (click)="removeGuests(item.id, index_)"></i>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!-- <div class="col-lg-12 m-t-15">
                      <div class="form-group">
                        <label for="archivos" class="f-s-11">Subir fotos o documentos PDF</label>
                        <input type="file" id="archivos" multiple accept=".pdf,image/*"
                          (change)="onFilesSelected($event)" class="form-control form-control-sm" />
                      </div>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="card mb-0">
              <div class="card-header book__accordion__header" id="headingTransport">
                <h5 class="mb-0 mt-0 font-14">
                  <a data-parent="#accordion" aria-controls="transports" class="book__accordion__title">
                    <i class="fas fa-bus m-r-5"></i>Recojos/traslados
                  </a>
                  <a class="btn btn-sm btn-info m-l-10 f-s-9 text-white" (click)="addTransfers()">Agregar
                    <i class="fas fa-plus m-l-2"></i>
                  </a>
                </h5>
              </div>
              <div id="transports" class="collapse show" aria-labelledby="headingTransport" data-parent="#accordion">
                <div class="card-body p-l-10 p-r-10">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="table-responsive">
                        <table class="table mb-0 table-sm">
                          <thead class="thead-default">
                            <tr>
                              <th class="text-center w-5"></th>
                              <th>TIPO transfer</th>
                              <th class="position-relative nowrap text-center w-10">N°Pax <span class="required"></span>
                              </th>
                              <th>Procedencia/Destino</th>
                              <th>Referencia (#vuelo,empresa)</th>
                              <th class="w-30 position-relative">Fecha y Hora <span class="required"></span></th>
                              <th class="text-center">Obs.</th>
                              <th class="text-center"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngIf="detail_transfers.length == 0">
                              <tr>
                                <td colspan="4"><span>Aun no se han agregado huéspedes</span></td>
                              </tr>
                            </ng-container>
                            <ng-container *ngIf="detail_transfers.length > 0">
                              <tr *ngFor="let item of detail_transfers; let index_ = index">
                                <td class="text-center w-5">
                                  <ng-container *ngIf="item.typetransfer_id == 1">
                                    <i class="fas fa-plane-arrival text-success"></i>
                                  </ng-container>
                                  <ng-container *ngIf="item.typetransfer_id == 2">
                                    <i class="fas fa-plane-departure text-danger"></i>
                                  </ng-container>
                                </td>
                                <td>
                                  <select class="form-control sale__inputSelect" id="typeTransferSelected{{index_}}"
                                    (change)="changeTypeTransfer($event.target, index_)">
                                  </select>
                                </td>
                                <td class="nowrap text-center w-10">
                                  <input type="text" id="nro_pax{{index_}}" class="form-control sale__input text-center"
                                    value="{{item.nro_pax}}" (keyup)="changeNroPax($event.target, index_)" numeric
                                    onclick="click_input(this)">
                                </td>
                                <td>
                                  <select class="form-control sale__inputSelect" id="arrivalPlaceSelected{{index_}}"
                                    (change)="changeArrivalPlace($event.target, index_)">
                                  </select>
                                </td>
                                <td>
                                  <input type="text" id="reference_place{{index_}}"
                                    class="form-control sale__input f-s-11" value="{{item.reference_place}}"
                                    (keyup)="changeReferencePlace($event.target, index_)">
                                </td>
                                <td class="w-30">
                                  <div class="input-group">
                                    <input type="date" class="form-control text-center sale__input f-s-12"
                                      id="date_transfer{{index_}}" value="{{item.date_transfer}}"
                                      (change)="changeDateTransfer($event.target, index_)">
                                    <div class="input-group-append" style="height: 25px;">
                                      <div class="input-group-text p-l-2 p-r-2">-</div>
                                    </div>
                                    <div class="input-group-append">
                                      <input type="time" class="form-control sale__input" value="{{item.time_transfer}}"
                                        id="time_transfer" (change)="changeTimeTransfer($event.target, index_)">
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <input type="text" id="transfer_observations{{index_}}"
                                    class="form-control sale__input f-s-11" value="{{item.observations}}"
                                    (keyup)="changeTransferObservations($event.target, index_)">
                                </td>
                                <td class="text-center">
                                  <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                    (click)="removeTransfers(item.id, index_)"></i>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="card mb-0">
              <div class="card-header book__accordion__header" id="headingConsumers">
                <h5 class="mb-0 mt-0 font-14">
                  <a data-parent="#accordion" aria-controls="consumers" class="book__accordion__title">
                    <i class="fas fa-shopping-bag m-r-5"></i>Consumos
                  </a>
                </h5>
              </div>
              <div id="consumers" class="collapse show" aria-labelledby="headingConsumers" data-parent="#accordion">
                <div class="card-body p-l-10 p-r-10">
                  <div class="row">
                    <div class="col-lg-12">
                      <span>Consumos</span>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <!--summary booking-->

            <div class="card mb-0 book__summary p-t-20 p-b-20" style="background: aliceblue;">
              <div class="col-lg-12">
                <ng-container>
                  <div class="row justify-content-md-end">
                    <div class="col-lg-3">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text bold text-primary">TOTAL RESERVA</span>
                        </span>
                        <input type="text" id="total_booking"
                          class="form-control form-control-sm text-right bold text-primary f-s-14" value="{{toolsService.momeySol()}}{{total}}"
                          numeric decimals="2" disabled>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <!-- <ng-container *ngIf="isEdit">
                  <div class="row justify-content-md-end">
                    <div class="col-lg-3">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text bold text-primary">T.RESERVA {{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" class="form-control form-control-sm text-right bold text-primary f-s-14"
                          id="total_tours" onclick="click_input(this)" formControlName="total" numeric decimals="2">
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text bold f-s-12">PAGADO {{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" class="form-control form-control-sm text-right bold f-s-14"
                          id="total_paid" numeric decimals="2" disabled value="{{item.value.total_paid}}">
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <div class="input-group">
                        <span class="input-group-prepend">
                          <span class="input-group-text text-danger bold f-s-12">S.PENDIENTE {{toolsService.momeySol()}}</span>
                        </span>
                        <input type="text" class="form-control form-control-sm text-right text-danger bold f-s-14"
                          id="total_paid" numeric decimals="2" disabled value="{{(item.value.total - item.value.total_paid).toFixed(2)}}">
                      </div>
                    </div>
                  </div>
                </ng-container> -->
                <div class="text-right m-t-15" *ngIf="isEdit && item.dirty">
                  <span class="badge badge-info">Clic en "Guardar Cambios" para registra los cambios realizados</span>
                </div>
              </div>
            </div>

          </div>
          <div class="form-group col-lg-12 form__footerBtn btns-fixeds p-l-0 p-r-0 ">
            <div class="text-right">
              <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
              <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                <i class="far fa-save m-r-5"></i>
                Guardar
                <ng-container *ngIf="isEdit">
                  Cambios
                </ng-container>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- Modal detalle de noches -->
  <div id="modalNights" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header" *ngIf="bedroomSelected != null">
          <h5 class="modal-title">Detalle — <strong> HAB {{bedroomSelected.code_number}} :
              {{bedroomSelected.roomtype.description}}</strong></h5>
          <a type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="removedetailRateBedroom()">
            <span aria-hidden="true">&times;</span>
          </a>
        </div>
        <div class="modal-body modal-night" *ngIf="bedroomSelected != null">
          <table class="table table-bordered">
            <thead class="thead-default">
              <tr>
                <th>Fecha</th>
                <!-- <th>Tipo Tarifa</th> -->
                <th class="text-center">Tarifa x noche</th>
                <th>Origen Tarifa</th>
                <!-- <th>Tipo tarifa</th> -->
                <!-- <th>Extra aplicado</th> -->
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rate of bedroomSelected.daily_rates; let index = index">
                <td>{{rate.date | date: 'mediumDate'}}</td>
                <!-- <td>{{typeRateObj.description}}</td> -->
                <td class="text-center">{{toolsService.momeySol()}}{{rate.rate}}</td>
                <td>
                  <ng-container *ngIf="rate.origin == 'base'">Config.Tipo Habitación</ng-container>
                  <ng-container *ngIf="rate.origin == 'season'">Config.Temporada</ng-container>
                  <ng-container *ngIf="rate.origin == 'agreement'">Config.Convenio</ng-container>
                </td>
              </tr>
            </tbody>
          </table>

          <ng-container *ngIf="bedroomSelected.detail_charges.length > 0">
            <table class="table table-bordered m-t-15">
              <thead class="thead-default">
                <tr>
                  <th>Extras agregados <i class="fas fa-plus text-success m-l-4"></i></th>
                  <th class="text-center">Cant.</th>
                  <th>Tarifa</th>
                  <th>SubTotal</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let charge of bedroomSelected.detail_charges">
                  <td>{{charge.description}}</td>
                  <td class="text-center">{{charge.quantity}}</td>
                  <td>{{toolsService.momeySol()}}{{charge.price}} * ({{bedroomSelected.number_nights}} noches)</td>
                  <td>{{toolsService.momeySol()}}{{(charge.price*charge.quantity)*bedroomSelected.number_nights}}</td>
                </tr>
              </tbody>
            </table>
          </ng-container>

        </div>
        <div class="modal-footer" *ngIf="bedroomSelected != null">
          <div class="me-auto bold f-s-15 m-r-15">TOTAL HABITACIÓN:
            {{toolsService.momeySol()}}{{bedroomSelected.subtotal}}
          </div>
          <button type="button" class="btn btn-secondary" data-dismiss="modal"
            (click)="removedetailRateBedroom()">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
  <!-- =============== -->
</div>



<app-client-extends (onSubmitEvent)="extendsClient($event)"></app-client-extends>
<app-search-available-bedrooms-extends (onSubmitEvent)="extendsBedrooms($event)">
</app-search-available-bedrooms-extends>
<app-guests-extends (onSubmitEvent)="extendsGuests($event)"></app-guests-extends>
